
export const emailTemplates = [
  {
    id: 1,
    name: 'Price Drop Alert',
    slug: 'price-drop',
    subject: '🎉 Price Drop Alert: {{product_name}} is now {{current_price}}!',
    description: 'Sent when a tracked product drops below the target price',
    category: 'alerts',
    isActive: true,
    lastModified: '2024-06-15',
    variables: [
      'product_name',
      'product_image',
      'original_price',
      'current_price',
      'savings_amount',
      'savings_percent',
      'retailer_name',
      'product_url',
    ],
    htmlContent: `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
</head>
<body style="margin: 0; padding: 0; background-color: #f3f4f6; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;">
  <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #f3f4f6; padding: 40px 20px;">
    <tr>
      <td align="center">
        <table width="600" cellpadding="0" cellspacing="0" style="background-color: #ffffff; border-radius: 16px; overflow: hidden; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
          <!-- Header -->
          <tr>
            <td style="background: linear-gradient(135deg, #14b8a6 0%, #10b981 100%); padding: 32px; text-align: center;">
              <h1 style="color: #ffffff; margin: 0; font-size: 28px; font-weight: 700;">Price Drop Alert! 🎉</h1>
              <p style="color: rgba(255,255,255,0.9); margin: 8px 0 0; font-size: 16px;">Great news - a product you're tracking just dropped in price!</p>
            </td>
          </tr>
          <!-- Product -->
          <tr>
            <td style="padding: 32px;">
              <table width="100%" cellpadding="0" cellspacing="0">
                <tr>
                  <td width="140" style="vertical-align: top;">
                    <img src="{{product_image}}" alt="{{product_name}}" style="width: 120px; height: 120px; object-fit: contain; border-radius: 12px; background: #f9fafb;">
                  </td>
                  <td style="vertical-align: top; padding-left: 20px;">
                    <h2 style="margin: 0 0 8px; font-size: 20px; color: #111827;">{{product_name}}</h2>
                    <p style="margin: 0 0 16px; color: #6b7280; font-size: 14px;">Available at {{retailer_name}}</p>
                    <table cellpadding="0" cellspacing="0">
                      <tr>
                        <td style="padding-right: 16px;">
                          <p style="margin: 0; color: #9ca3af; font-size: 12px; text-transform: uppercase;">Was</p>
                          <p style="margin: 4px 0 0; color: #9ca3af; font-size: 18px; text-decoration: line-through;">{{original_price}}</p>
                        </td>
                        <td>
                          <p style="margin: 0; color: #10b981; font-size: 12px; text-transform: uppercase; font-weight: 600;">Now</p>
                          <p style="margin: 4px 0 0; color: #10b981; font-size: 24px; font-weight: 700;">{{current_price}}</p>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
              <!-- Savings Badge -->
              <div style="background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%); border-radius: 12px; padding: 16px; margin-top: 24px; text-align: center;">
                <p style="margin: 0; color: #92400e; font-size: 14px;">You're saving</p>
                <p style="margin: 4px 0 0; color: #92400e; font-size: 28px; font-weight: 700;">{{savings_amount}} ({{savings_percent}}% off)</p>
              </div>
              <!-- CTA Button -->
              <div style="text-align: center; margin-top: 32px;">
                <a href="{{product_url}}" style="display: inline-block; background: linear-gradient(135deg, #14b8a6 0%, #10b981 100%); color: #ffffff; text-decoration: none; padding: 16px 48px; border-radius: 12px; font-size: 16px; font-weight: 600;">Shop Now →</a>
              </div>
            </td>
          </tr>
          <!-- Footer -->
          <tr>
            <td style="background-color: #f9fafb; padding: 24px; text-align: center; border-top: 1px solid #e5e7eb;">
              <p style="margin: 0; color: #6b7280; font-size: 12px;">You received this email because you set a price alert for this product.</p>
              <p style="margin: 8px 0 0; color: #9ca3af; font-size: 12px;"><a href="#" style="color: #14b8a6;">Manage alerts</a> • <a href="#" style="color: #14b8a6;">Unsubscribe</a></p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
    `,
  },
  {
    id: 2,
    name: 'Weekly Price Summary',
    slug: 'weekly-summary',
    subject: '📊 Your Weekly Price Tracker Summary',
    description: 'Weekly digest of all tracked products and their price changes',
    category: 'digest',
    isActive: true,
    lastModified: '2024-06-10',
    variables: [
      'user_name',
      'total_tracked',
      'total_savings',
      'products_dropped',
      'products_list',
    ],
    htmlContent: `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
</head>
<body style="margin: 0; padding: 0; background-color: #f3f4f6; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;">
  <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #f3f4f6; padding: 40px 20px;">
    <tr>
      <td align="center">
        <table width="600" cellpadding="0" cellspacing="0" style="background-color: #ffffff; border-radius: 16px; overflow: hidden;">
          <tr>
            <td style="background: linear-gradient(135deg, #14b8a6 0%, #10b981 100%); padding: 32px; text-align: center;">
              <h1 style="color: #ffffff; margin: 0; font-size: 24px;">Weekly Price Summary 📊</h1>
              <p style="color: rgba(255,255,255,0.9); margin: 8px 0 0;">Hi {{user_name}}, here's your weekly update</p>
            </td>
          </tr>
          <tr>
            <td style="padding: 32px;">
              <table width="100%" cellpadding="0" cellspacing="0">
                <tr>
                  <td width="33%" style="text-align: center; padding: 16px;">
                    <p style="margin: 0; font-size: 32px; font-weight: 700; color: #14b8a6;">{{total_tracked}}</p>
                    <p style="margin: 4px 0 0; color: #6b7280; font-size: 14px;">Products Tracked</p>
                  </td>
                  <td width="33%" style="text-align: center; padding: 16px; border-left: 1px solid #e5e7eb; border-right: 1px solid #e5e7eb;">
                    <p style="margin: 0; font-size: 32px; font-weight: 700; color: #10b981;">{{products_dropped}}</p>
                    <p style="margin: 4px 0 0; color: #6b7280; font-size: 14px;">Price Drops</p>
                  </td>
                  <td width="33%" style="text-align: center; padding: 16px;">
                    <p style="margin: 0; font-size: 32px; font-weight: 700; color: #f59e0b;">{{total_savings}}</p>
                    <p style="margin: 4px 0 0; color: #6b7280; font-size: 14px;">Potential Savings</p>
                  </td>
                </tr>
              </table>
              <div style="margin-top: 32px;">
                <h3 style="margin: 0 0 16px; color: #111827; font-size: 18px;">Your Tracked Products</h3>
                {{products_list}}
              </div>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
    `,
  },
  {
    id: 3,
    name: 'New User Welcome',
    slug: 'welcome',
    subject: 'Welcome to Ohprice! Start Saving Today 🎯',
    description: 'Welcome email sent to new users after registration',
    category: 'onboarding',
    isActive: true,
    lastModified: '2024-06-01',
    variables: ['user_name', 'verification_link'],
    htmlContent: `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
</head>
<body style="margin: 0; padding: 0; background-color: #f3f4f6; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;">
  <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #f3f4f6; padding: 40px 20px;">
    <tr>
      <td align="center">
        <table width="600" cellpadding="0" cellspacing="0" style="background-color: #ffffff; border-radius: 16px; overflow: hidden;">
          <tr>
            <td style="background: linear-gradient(135deg, #14b8a6 0%, #10b981 100%); padding: 48px 32px; text-align: center;">
              <h1 style="color: #ffffff; margin: 0; font-size: 32px; font-weight: 700;">Welcome to Ohprice! 🎉</h1>
            </td>
          </tr>
          <tr>
            <td style="padding: 40px 32px;">
              <p style="margin: 0 0 24px; color: #374151; font-size: 16px; line-height: 1.6;">Hi {{user_name}},</p>
              <p style="margin: 0 0 24px; color: #374151; font-size: 16px; line-height: 1.6;">Welcome to Ohprice! We're excited to help you find the best deals and save money on your favorite products.</p>
              <h3 style="margin: 32px 0 16px; color: #111827;">Here's what you can do:</h3>
              <ul style="margin: 0; padding: 0 0 0 20px; color: #374151;">
                <li style="margin-bottom: 12px;">Track prices across multiple retailers</li>
                <li style="margin-bottom: 12px;">Set custom price alerts</li>
                <li style="margin-bottom: 12px;">Compare products side by side</li>
                <li style="margin-bottom: 12px;">Get notified when prices drop</li>
              </ul>
              <div style="text-align: center; margin-top: 40px;">
                <a href="{{verification_link}}" style="display: inline-block; background: linear-gradient(135deg, #14b8a6 0%, #10b981 100%); color: #ffffff; text-decoration: none; padding: 16px 48px; border-radius: 12px; font-size: 16px; font-weight: 600;">Start Tracking Prices</a>
              </div>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
    `,
  },
  {
    id: 4,
    name: 'Price Increase Warning',
    slug: 'price-increase',
    subject: '⚠️ Price Alert: {{product_name}} price is rising',
    description: 'Sent when a tracked product price increases significantly',
    category: 'alerts',
    isActive: false,
    lastModified: '2024-05-20',
    variables: [
      'product_name',
      'product_image',
      'old_price',
      'new_price',
      'increase_percent',
      'product_url',
    ],
    htmlContent: `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
</head>
<body style="margin: 0; padding: 0; background-color: #f3f4f6; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;">
  <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #f3f4f6; padding: 40px 20px;">
    <tr>
      <td align="center">
        <table width="600" cellpadding="0" cellspacing="0" style="background-color: #ffffff; border-radius: 16px; overflow: hidden;">
          <tr>
            <td style="background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%); padding: 32px; text-align: center;">
              <h1 style="color: #ffffff; margin: 0; font-size: 24px;">Price Increase Alert ⚠️</h1>
              <p style="color: rgba(255,255,255,0.9); margin: 8px 0 0;">A product you're tracking has increased in price</p>
            </td>
          </tr>
          <tr>
            <td style="padding: 32px; text-align: center;">
              <img src="{{product_image}}" alt="{{product_name}}" style="width: 150px; height: 150px; object-fit: contain; border-radius: 12px; background: #f9fafb;">
              <h2 style="margin: 16px 0 8px; color: #111827;">{{product_name}}</h2>
              <p style="margin: 0; color: #6b7280;">Price increased by <span style="color: #dc2626; font-weight: 600;">{{increase_percent}}%</span></p>
              <table cellpadding="0" cellspacing="0" style="margin: 24px auto;">
                <tr>
                  <td style="padding-right: 24px; text-align: center;">
                    <p style="margin: 0; color: #9ca3af; font-size: 12px;">Was</p>
                    <p style="margin: 4px 0 0; color: #10b981; font-size: 20px;">{{old_price}}</p>
                  </td>
                  <td style="text-align: center;">
                    <p style="margin: 0; color: #9ca3af; font-size: 12px;">Now</p>
                    <p style="margin: 4px 0 0; color: #dc2626; font-size: 20px; font-weight: 700;">{{new_price}}</p>
                  </td>
                </tr>
              </table>
              <a href="{{product_url}}" style="display: inline-block; background: #f3f4f6; color: #374151; text-decoration: none; padding: 12px 32px; border-radius: 8px; font-size: 14px; font-weight: 500;">View Product</a>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
    `,
  },
  {
    id: 5,
    name: 'Alert Triggered Confirmation',
    slug: 'alert-triggered',
    subject: '✅ Your price alert for {{product_name}} was triggered!',
    description: 'Confirmation when a price alert is successfully triggered',
    category: 'alerts',
    isActive: true,
    lastModified: '2024-06-12',
    variables: ['product_name', 'target_price', 'current_price', 'product_url'],
    htmlContent: `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
</head>
<body style="margin: 0; padding: 0; background-color: #f3f4f6; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;">
  <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #f3f4f6; padding: 40px 20px;">
    <tr>
      <td align="center">
        <table width="600" cellpadding="0" cellspacing="0" style="background-color: #ffffff; border-radius: 16px; overflow: hidden;">
          <tr>
            <td style="background: linear-gradient(135deg, #10b981 0%, #059669 100%); padding: 32px; text-align: center;">
              <div style="width: 64px; height: 64px; background: rgba(255,255,255,0.2); border-radius: 50%; margin: 0 auto 16px; display: flex; align-items: center; justify-content: center;">
                <span style="font-size: 32px;">✅</span>
              </div>
              <h1 style="color: #ffffff; margin: 0; font-size: 24px;">Alert Triggered!</h1>
            </td>
          </tr>
          <tr>
            <td style="padding: 32px; text-align: center;">
              <p style="margin: 0 0 16px; color: #374151; font-size: 16px;">Your price alert for <strong>{{product_name}}</strong> has been triggered!</p>
              <div style="background: #f0fdf4; border-radius: 12px; padding: 24px; margin: 24px 0;">
                <p style="margin: 0; color: #6b7280; font-size: 14px;">Target Price: <span style="color: #374151; font-weight: 600;">{{target_price}}</span></p>
                <p style="margin: 8px 0 0; color: #6b7280; font-size: 14px;">Current Price: <span style="color: #10b981; font-weight: 700; font-size: 18px;">{{current_price}}</span></p>
              </div>
              <a href="{{product_url}}" style="display: inline-block; background: linear-gradient(135deg, #10b981 0%, #059669 100%); color: #ffffff; text-decoration: none; padding: 16px 48px; border-radius: 12px; font-size: 16px; font-weight: 600;">Buy Now</a>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
    `,
  },
];

export const emailCategories = [
  { id: 'alerts', name: 'Price Alerts', icon: 'ri-notification-3-line', color: 'bg-amber-100 text-amber-600' },
  { id: 'digest', name: 'Digests', icon: 'ri-mail-line', color: 'bg-teal-100 text-teal-600' },
  { id: 'onboarding', name: 'Onboarding', icon: 'ri-user-add-line', color: 'bg-emerald-100 text-emerald-600' },
  { id: 'transactional', name: 'Transactional', icon: 'ri-exchange-line', color: 'bg-cyan-100 text-cyan-600' },
];
